<ng-container *ngTemplateOutlet="hasError ? errorTemplate : mainContent"></ng-container>

<ng-template #mainContent>
  <!-- Main content goes here -->
  <app-dialog-header titleTranslateKey="scheduler.setup.segment-chooser.title" (closeClicked)="onCancelClick()">
  </app-dialog-header>

  <mat-dialog-content class="fullscreen-dialog">
    <mat-selection-list #segmentSelection [(ngModel)]="selectedOptions" [compareWith]="compareFunction">
      @for (currentSegment of this.segments; track currentSegment) {
      <mat-list-option [value]="currentSegment">
        {{ currentSegment.code }} - {{ currentSegment.description }}
      </mat-list-option>
      }
    </mat-selection-list>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="save()" color="primary" mat-raised-button type="submit">Save</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #errorTemplate>
  <mat-error>
    <h2>Error: Something went wrong!</h2>
    <p>Please ensure the row of the booking profile has been saved before a segment is selected!</p>
  </mat-error>
</ng-template>